import UserMenu from './UserMenu';

export { UserMenu };
export default UserMenu;
